import {CallMeContext, CallMeProvider} from './call-me-context';

export {CallMeContext, CallMeProvider};

export default CallMeContext;
